import _ from 'lodash';
import { required } from 'vuelidate/lib/validators';

const mStep = {
  title: 'Next Review',
  description: 'Please provide details on the last investment strategy review.',
};

const options = [
  {
    value: () => 'annually as part of the Trustee\'s normal review cycle',
  },
  {
    input: 0,
    parts: [
      'in',
      'month(s) reflecting the current uncertain environment',
    ],
    value() {
      return `${this.parts[0]} ${this.input} ${this.parts[1]}`;
    }
    ,
  },
];

export default {
  name: 'inv-strat-review-next-review',
  data: () => ({
    mStep,
    options: _.cloneDeep(options),
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    nextReview: {
      get() {
        return this.getItem.nextReview.type;
      },
      set(value) {
        this.setItem({ nextReview: { type: _.cloneDeep(value) } });
      },
    },
  },
  mounted() {
    if (this.nextReview && this.nextReview !== options[0]) {
      // eslint-disable-next-line prefer-destructuring
      this.options[1].input = this.nextReview.split(' ')[1];
    }
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  validations: {
    nextReview: {
      required,
    },
  },
};
